<script setup lang="ts">
const store = useStore()
const error = computed(() => store.formError)
const isLoading = computed(() => store.isLoading)

interface LoginForm {
  email: string
  password: string
}

const form = ref<LoginForm>({
  email: '',
  password: '',
})

async function submit() {
  console.log('submit')
  await store.loginUser(form.value.email, form.value.password)
  if (!error.value) {
    form.value.email = ''
    form.value.password = ''
    store.sidebarVisible = false
  }
}
</script>

<template>
  <h2>Kirjaudu</h2>

  <form @submit.prevent="submit" class="space-y-4 max-w-md pt-4 userform">
    <div v-if="error" class="p-3 text-red-700 bg-red-100 rounded-sm">
      {{ error }}
    </div>

    <div class="space-y-1">
      <label for="email">Sähköpostiosoite</label>
      <input id="email" v-model="form.email" type="email" required />
    </div>

    <div class="space-y-1">
      <label for="password">Salasana</label>
      <input id="password" v-model="form.password" type="password" required minlength="8" />
    </div>

    <button type="submit" :disabled="isLoading" class="">
      {{ isLoading ? 'Kirjaudutaan...' : 'Kirjaudu' }}
    </button>
  </form>
</template>
